import React from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import moment from 'moment';
import salesInIcon from '../../img/salesin.svg';
import salesOutIcon from '../../img/salesout.svg';
import collectNoteRedIcon from '../../img/trucknote_red.svg';
import collectNoteBlueIcon from '../../img/trucknote_blue.svg';
import collectNoteGreenIcon from '../../img/trucknote_green.svg';
import collectCoinRedIcon from '../../img/truckcoin_red.svg';
import collectCoinBlueIcon from '../../img/truckcoin_blue.svg';
import collectCoinGreenIcon from '../../img/truckcoin_green.svg';
import collectEnvRedIcon from '../../img/truckenv_red.svg';
import collectEnvBlueIcon from '../../img/truckenv_blue.svg';
import collectEnvGreenIcon from '../../img/truckenv_green.svg';
import FontIcon from 'material-ui/FontIcon';
import {LoomisColors} from '../../lib/LoomisColors';
import translate from '../../lib/i18n/translate'
import { Row, Col } from 'react-flexbox-grid';
import numeral from 'numeral';

import './TransactionList.css'

const exchangeInStyle = {
    color: LoomisColors.yellow,
};

const exchangeOutStyle = {
    color: LoomisColors.darkRed,
};

const floatInStyle = {
    color: LoomisColors.yellow,
};

const floatOutStyle = {
    color: LoomisColors.red,
};

const counterfeitStyle = {
    color: LoomisColors.red,
};

const envelopeStyle = {
    color: LoomisColors.yellow,
};

const collectionIcon = (confirm, cashtype) => {
    if (!confirm) {
        if (cashtype === 'NOTES') {return collectNoteBlueIcon}
        if (cashtype === 'COINS') {return collectCoinBlueIcon}
        if (cashtype === 'ENVELOPE') {return collectEnvBlueIcon}
    } else if (confirm.diff) {
        if (cashtype === 'NOTES') {return collectNoteRedIcon}
        if (cashtype === 'COINS') {return collectCoinRedIcon}
        if (cashtype === 'ENVELOPE') {return collectEnvRedIcon}
    } else {
        if (cashtype === 'NOTES') {return collectNoteGreenIcon}
        if (cashtype === 'COINS') {return collectCoinGreenIcon}
        if (cashtype === 'ENVELOPE') {return collectEnvGreenIcon}
    }
}

const collectionTitle = (confirm, cashtype, strings) => {
    if (!confirm) {
        if (cashtype === 'NOTES') {
            return (strings.HoverCollectionNotes)
        }
        if (cashtype === 'COINS') {
            return strings.HoverCollectionCoins
        }
        if (cashtype === 'ENVELOPE') {
            return strings.HoverCollectionEnvelope
        }
    } else if (confirm.diff) {
        if (cashtype === 'NOTES') {
            return strings.HoverCollectionNotesNOK
        }
        if (cashtype === 'COINS') {
            return strings.HoverCollectionCoinsNOK
        }
        if (cashtype === 'ENVELOPE') {
            return strings.HoverCollectionEnvelopeNOK
        }
    } else {
        if (cashtype === 'NOTES') {
            return strings.HoverCollectionNotesOK
        }
        if (cashtype === 'COINS') {
            return strings.HoverCollectionCoinsOK
        }
        if (cashtype === 'ENVELOPE') {
            return strings.HoverCollectionEnvelopeOK
        }
    }
}

const TransactionList = (props) => {
    const {data, strings} = props

    return (
        <div className="TransactionList">

            <Row middle="xs">
                <Col xs={6} sm={6} md={6} lg={6}>
                    <div className="MiddleHeader">
                        <FontIcon className="material-icons left">swap_horiz</FontIcon>
                        <div className="MiddleHeaderText">{strings.Transactions}</div>
                    </div>
                </Col>
            </Row>
            <Table>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                    <TableRow>
                        <TableHeaderColumn style={{width:'50px'}} className="centerText">{strings.Type}</TableHeaderColumn>
                        <TableHeaderColumn>{strings.Operator}</TableHeaderColumn>
                        <TableHeaderColumn>{strings.Device}</TableHeaderColumn>
                        <TableHeaderColumn style={{width:'110px'}} className="rightText hide-xs">{strings.SalesDay}</TableHeaderColumn>
                        <TableHeaderColumn className="rightText">{strings.Amount}</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false} showRowHover={true}>
                    {
                        {data}.data.map((tx, i) => (
                            <TableRow key={i}>
                                <TableRowColumn style={{width:'50px'}} className="centerText">
                                    {tx.type === 'DEPOSIT' && <img src={salesInIcon} title={strings.HoverDeposit} alt="Deposit" className="depositIcon"/>}
                                    {tx.type === 'COLLECTION' && <img src={collectionIcon(tx.confirm, tx.cashType)} title={collectionTitle(tx.confirm, tx.cashType, strings)} alt="Collection" className="depositIcon"/>}
                                    {tx.type === 'SALES' &&  <img src={salesInIcon} title={strings.HoverSalesIn} alt="SalesIn" className="depositIcon"/>}
                                    {tx.type === 'SALESIN' &&  <img src={salesInIcon} title={strings.HoverSalesIn} alt="SalesIn" className="depositIcon"/>}
                                    {tx.type === 'SALESOUT' &&  <img src={salesOutIcon} title={strings.HoverSalesOut} alt="SalesOut" className="depositIcon"/>}
                                    {tx.type === 'EXCHANGEIN' && <FontIcon className="material-icons" title={strings.HoverExchangeIn} style={exchangeInStyle}>swap_horiz</FontIcon>}
                                    {tx.type === 'EXCHANGEOUT' && <FontIcon className="material-icons" title={strings.HoverExchangeOut} style={exchangeOutStyle}>swap_horiz</FontIcon>}
                                    {tx.type === 'EXCHANGE' && <FontIcon className="material-icons" title={strings.HoverExchange} style={exchangeOutStyle}>swap_horiz</FontIcon>}
                                    {tx.type === 'FLOATIN' && <FontIcon className="material-icons" title={strings.HoverRefill} style={floatInStyle}>system_update_alt</FontIcon>}
                                    {tx.type === 'FLOATOUT' && <FontIcon className="material-icons" title={strings.HoverDrain} style={floatOutStyle}>eject</FontIcon>}
                                    {tx.type === 'COUNTERFEIT' && <FontIcon className="material-icons" title={strings.HoverCounterfeit} style={counterfeitStyle}>priority_high</FontIcon>}
                                    {tx.type === 'ENVELOPE' && <FontIcon className="material-icons" title={strings.HoverManualDeposit} style={envelopeStyle}>mail_outline</FontIcon>}
                                    {tx.type === 'UNKNOWN_ENVELOPE' && <FontIcon className="material-icons" title={strings.HoverManualDeposit} style={envelopeStyle}>mail_outline</FontIcon>}
                                    {tx.type === 'INTERNAL' && <FontIcon className="material-icons" title={strings.HoverInternal}>cached</FontIcon>}
                                    {tx.type === 'NOP' && <FontIcon className="material-icons" title={strings.HoverNOP}>clear</FontIcon>}
                                    <div className="TransactionTime">{moment(tx.when).format("HH:mm")}</div>
                                </TableRowColumn>
                                <TableRowColumn>{tx.operatorUserName}</TableRowColumn>
                                <TableRowColumn>
                                    <div style={{color:(tx.deviceName==='DELETED'?LoomisColors.red:LoomisColors.black)}}>{tx.deviceName}</div>
                                </TableRowColumn>
                                <TableRowColumn style={{width:'110px'}} className="rightText hide-xs">
                                    {tx.salesDay}
                                </TableRowColumn>
                                <TableRowColumn className="rightText">
                                    {tx.sums.map((s,idx)=>(<div style={{float:'right'}} key={idx}>{numeral(s.amount/100).format('0,0.00')} <span style={{color:LoomisColors.darkGrey,fontSize: 10,}}>{s.currency}</span></div>))}
                                    <br/>
                                    <div>{tx.type === 'COLLECTION' && tx.confirm !== null && tx.confirm.diff === true && tx.confirm.sums.map((c,idx)=>(
                                        <div style={{float:'right', color:(c.diff?LoomisColors.red:LoomisColors.green)}} key={idx}>{numeral(c.amount/100).format('0,0.00')} <span style={{color:LoomisColors.darkGrey,fontSize: 10,}}>{c.currency}</span></div>
                                    ))}</div>
                                </TableRowColumn>
                            </TableRow>
                        ))
                    }
                    </TableBody>
            </Table>
        </div>
    )
};

export default translate('TransactionList')(TransactionList);




// WEBPACK FOOTER //
// ./src/components/transactionDay/TransactionList.js